const actions = {
    incrementLoadingCount ({ commit }) {
        return commit('incrementLoadingCount')
    },
    decrementLoadingCount ({ commit }) {
        return commit('decrementLoadingCount')
    }
};

export default actions;